import { styleOverrides } from "./styleOverrides";

const MuiSelect = {
  styleOverrides,
};

export { MuiSelect };
